export const API_GUARD = "company";

export const URL = "https://api.flexip.com.br/api";